import { Overlay } from "@omni/components/components/General/Overlay/overlay";
import { FlyoutMenu } from "@omni/components/components/Navigation/FlyoutMenu/flyoutMenu";
import { cn } from "@omni/utils/styles";

import { Link } from "@/components/Navigation/FlyoutMenu/components/link";

export const FlyoutMenuComponent = () => {
    const { open, onClose } = FlyoutMenu.useContext();

    return (
        <Overlay
            open={open}
            onClose={onClose}
            backdrop={true}
            overlayHeader={false}
            scrollLock={true}
        >
            <Overlay.Content
                className={cn("tw:page-container")}
                positionAtMount={true}
            >
                <FlyoutMenu.Content>
                    <FlyoutMenu.Categories>
                        <FlyoutMenu.Category>
                            <FlyoutMenu.Category.Title />
                            <FlyoutMenu.Category.Links>
                                <Link />
                            </FlyoutMenu.Category.Links>
                        </FlyoutMenu.Category>
                    </FlyoutMenu.Categories>
                </FlyoutMenu.Content>
            </Overlay.Content>
        </Overlay>
    );
};
